import React from 'react';
import styled from 'styled-components';

import Image from '@stencil/image';

import ArrowRightDetailsOneIcon from '../../../../Icons/ArrowRightDetailsOneIcon';

interface ITravellerPhoto {
  source: string;
  text: string;
  alternateText: string;
  noOfPhotos: number;
}

const TravellerPhotoUpload = ({source, text, alternateText, noOfPhotos}) => (
  <>
    <TravellerPhotoUploadOuterWrapDiv>
      <TravellerGalleryImage src={source} alt={alternateText} />
      <TravellerGalleryTxtWrapper>
        <TravellerGalleryTxtWrapDiv>
          <HotellierGalleryTxtSpan>{text}</HotellierGalleryTxtSpan>
          <RoundCircleWrapSpan>
            <RightArrowGalleryTraveller></RightArrowGalleryTraveller>
          </RoundCircleWrapSpan>
        </TravellerGalleryTxtWrapDiv>
        <TravellerGalleryTxtSpan>Photos({noOfPhotos})</TravellerGalleryTxtSpan>
      </TravellerGalleryTxtWrapper>
    </TravellerPhotoUploadOuterWrapDiv>
    <OverlayImageWrapDiv />
  </>
);

export default TravellerPhotoUpload;

const TravellerPhotoUploadOuterWrapDiv = styled.div(
  props => `
  display: flex;
  position:relative;
  width:100%;
`,
);

const TravellerGalleryImage = styled(Image)(
  props => `
    border-radius: ${props.theme.misc.borderRadius.xxxlarge};
    object-fit: cover;
    width:100%;
    height:9.8rem;
`,
);

const TravellerGalleryTxtWrapDiv = styled.div(
  props => `
    display: flex;
    justify-content:space-between;
`,
);

const TravellerGalleryTxtWrapper = styled.div(
  props => `
    display: flex;
    flex-direction: column;
    width:100%;
    position:absolute;
    padding:${props.theme.spacing.custom(12)};
    z-index:${props.theme.misc.zIndex.xxsmall};
`,
);

const TravellerGalleryTxtSpan = styled.p(
  props => `
    color:${props.theme.colors.goWhite.base};
    padding-top:${props.theme.spacing.custom(2)}

`,
);

const HotellierGalleryTxtSpan = styled.span(
  props => `
    font-weight:bold;
    color:${props.theme.colors.goWhite.base};
`,
);

const RoundCircleWrapSpan = styled.span(
  props => `
    width:1.6rem;
    height:1.6rem;
    background-color:${props.theme.colors.goWhite.base};
    position:relative;
    border-radius:50%;

`,
);

const RightArrowGalleryTraveller = styled(ArrowRightDetailsOneIcon)(
  props => `
    width:0.7rem;
    height:0.7rem;
    fill:${props.theme.colors.downriver.base};
    position :absolute;
    top:0.4rem;
    right:0.4rem;

  `,
);

const OverlayImageWrapDiv = styled.div(
  props => `

  position: absolute;
  bottom: ${props.theme.spacing.custom(6)};
  left: 0;
  top:0;
  width: 100%;
  height: 100%;
  background-color: ${props.theme.colors.shadow.dark};
  cursor: pointer;
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};

`,
);
